const statEmailNotificationReducerDefaultState = {
    data: {},
    loading: false,
    statEmailError: false,
    statEmailSuccess: false,
    successMessage: '',
    errorMessage: null
};

const statEmailNotificationReducer = (state = statEmailNotificationReducerDefaultState, action) => {
    switch (action.type) {
        case 'START_SEND_STAT_EMAIL':
            return {
                ...state,
                loading: true,
                statEmailError: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'SEND_STAT_EMAIL_SUCCESS':
            return {
                ...state,
                data: action.statDetails,
                loading: false,
                statEmailSuccess: true,
                error: false,
                errorMessage: null,
                successMessage: 'Stat email has been created',
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                statEmailError: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default statEmailNotificationReducer;
